<!-- Header Section -->
<header class="header">
    <div class="logo">Kiko VPN</div>
    <nav class="navigation">
        <a href="/home">Home</a>
        <a href="/downloads">Downloads</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
        <a href="/reseller">Reseller</a>
        <a href="/faq">Faq</a>
        <a href="/support">Support</a>
        <a href="/about">About Us</a>
    </nav>
</header>
<div class="about-us-container">
    <h2>About Us</h2>

    <section class="mission">
        <h3>Mission</h3>
        <p>{{ aboutContent.mission }}</p>
    </section>

    <section class="vision">
        <h3>Vision</h3>
        <p>{{ aboutContent.vision }}</p>
    </section>

    <section class="values">
        <h3>Our Values</h3>
        <ul>
            <li *ngFor="let value of aboutContent.values">{{ value }}</li>
        </ul>
    </section>

    <section class="team">
        <h3>Meet the Team</h3>
        <div class="team-members">
            <div *ngFor="let member of aboutContent.team" class="team-member">
                <img [src]="member.photo" alt="{{ member.name }}" class="team-photo" />
                <h4>{{ member.name }}</h4>
                <p>{{ member.role }}</p>
            </div>
        </div>
    </section>
</div>